import tracking from 'dibs-tracking';

const trackPageView = (viewMode = '') => {
    tracking.trackPageview({
        additional: {
            pageType: 'Other',
            pageSubType: 'Favorites',
            viewMode: viewMode.toLowerCase(),
        },
    });
};

export default trackPageView;
